angular.module('rjmNg.services').factory 'sql', [
  "$http"
  "$q"
  "$url"
  "app"
  ($http, $q, $url, app) ->
    run: (query) ->
      data =
        query: query
      $http
        method: "POST"
        data: data
        url: $url("/client/#{app.getClientId()}/sql")
        withCredentials: true
  ]
